import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { combineReducers } from "redux";

import assetsReducer from "./features/Assets/AssetsSlice";
import authReducer from "./features/Auth/authSlice";
import billingReducer from "./features/Billing/BillingSlice";
import courseReducer from "./features/Course/courseSlice";
import fileVaultReducer from "./features/FileVault/fileVault";
import helpReducer from "./features/Help/helpSlice";
import lessonReducer from "./features/Lesson/lesson.slice";
import myAccountReducer from "./features/MyAccount/myAccountSlice";
import noteReducer from "./features/Note/Notes.slice";
import createTestReducer from "./features/QuestionBank/CreateTest/createTest.slice";
import testReducer from "./features/QuestionBank/Test/test.slice";
import questionBankReducer from "./features/QuestionBank/questionBank.slice";
import quizReducer from "./features/Test/test.slice";
import takeTestReducer from "./features/Test/testAttempt.slice";
import themeReducer from "./features/Theme/theme.slice";
import notificationsReducer from "./features/notifications/notifications.slice";

const combinedReducer = combineReducers({
	auth: authReducer,
	courses: courseReducer,
	fileVault: fileVaultReducer,
	myAccount: myAccountReducer,
	lesson: lessonReducer,
	help: helpReducer,
	notifications: notificationsReducer,
	billing: billingReducer,
	createTest: createTestReducer,
	test: testReducer,
	notes: noteReducer,
	questionBank: questionBankReducer,
	takeTest: takeTestReducer,
	theme: themeReducer,
	quiz: quizReducer,
	assets: assetsReducer
});

const rootReducer = (state, action) => {
	// reset redux state on logout
	return action.type === "auth/clearAuth"
		? combinedReducer({ theme: state.theme } as RootState, action)
		: combinedReducer(state, action);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setupStore = () =>
	configureStore({
		reducer: rootReducer
	});

export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
